/** @jsx jsx */
import { styled, css, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// remove this when cleanup platform_editor_controls
// WS-2881 - We need to adjust the padding for the buttons to match the editor and shrink the "Add issue" icon
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BuiltInActionsOld = styled.div({
	padding: token('space.025'),
	display: 'flex',

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& > button, & > button:hover': {
		height: 'inherit',
		display: 'flex',
		alignItems: 'center',
	},

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
	'& > button:last-of-type span[role="presentation"]': {
		height: '20px',
		width: '20px',
	},
});

// remove this when cleanup platform_editor_controls
// WS-2881 - We need to adjust the padding for the buttons to match the editor and shrink the "Add issue" icon
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BuiltInActionsPatch = styled.div({
	padding: token('space.025'),
	display: 'flex',

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& > button, & > button:hover': {
		height: 'inherit',
		display: 'flex',
		alignItems: 'center',
	},

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
	'& > div > button, & > div > button:hover': {
		height: '100%',
		display: 'flex',
		alignItems: 'center',
	},

	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors
	'& > button:last-of-type span[role="presentation"]': {
		height: '20px',
		width: '20px',
	},
});

// remove this when cleanup platform_editor_controls
// WS-2881 - BuiltInActionsSimple does not include the "Add issue" icon, and does not need custom styling like the other styled components in this file
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BuiltInActionsSimple = styled.div({
	padding: token('space.050'),
	display: 'flex',
});

const disabledButtonWrapperStyle = css({
	position: 'relative',
});

export const DisabledButtonWrapper = (props) => <div css={disabledButtonWrapperStyle} {...props} />;

const disabledButtonOverlayStyle = css({
	position: 'absolute',
	width: '100%',
	height: '100%',
	zIndex: '1000',
	backgroundColor: 'transparent',
	cursor: 'not-allowed',
});

export const DisabledButtonOverlay = (props) => <div css={disabledButtonOverlayStyle} {...props} />;

const dividerStyleOld = css({
	margin: `5px ${token('space.025')}`,
	width: '1px',
	backgroundColor: token('color.border'),
});

export const DividerOld = (props) => <div css={dividerStyleOld} {...props} />;

const dividerStyle = css({
	width: '1px',
	backgroundColor: token('color.border'),
	marginLeft: token('space.050'),
	marginRight: token('space.050'),
	marginTop: token('space.negative.050'),
	marginBottom: token('space.negative.050'),
});

export const Divider = (props) => <div css={dividerStyle} {...props} />;
